<template>
  <div>
    <sbpps-student-icard v-if="tenant == 'sbpps'" />
    <zeal-student-icard v-else-if="tenant == 'zeal'" />
    <!-- <veis-student-icard v-else-if="tenant=='veis'"/> -->
    <wws-student-icard v-else-if="tenant == 'wws'" />
    <vvp-student-icard v-else-if="tenant == 'vvp'" />
    <eps-student-icard v-else-if="tenant == 'eps'" />
    <sanjivani-student-icard v-else-if="tenant == 'sanjivani'" />
    <uwws-student-icard v-else-if="tenant == 'uwws'" />
    <tmv-student-icard v-else-if="tenant == 'tmvidyalaya'" />
    <div v-else>Under Development.....</div>
  </div>
</template>

<script>
// import sbpps_student_icard from "./SbppsStudentIcard.vue";
// import zeal_student_icard from "./ZealStudentIcard.vue";
// import wws_student_icard from "./WwsStudentIcard.vue";
// // import veis_student_icard from './VeisStudentIcard.vue'
// import vvp_student_icard from "./VvpStudentIcard.vue";
// import eps_student_icard from "./EpsStudentIcard.vue";
export default {
  components: {
    "sbpps-student-icard": () => import('./SbppsStudentIcard'),
    "zeal-student-icard": () => import('./ZealStudentIcard'),
    // 'veis-student-icard':veis_student_icard,
    "wws-student-icard": () => import('./WwsStudentIcard'),
    "vvp-student-icard": () => import('./VvpStudentIcard'),
    "eps-student-icard": () => import('./EpsStudentIcard'),
    "sanjivani-student-icard": () => import('./SanjivaniStudentIcard'),
    "uwws-student-icard": () => import('./UwwsStudentIcard'),
    "tmv-student-icard": () => import('./TMVStudentIcard'),
  },
  data: () => ({
    tenant: null,
  }),
  created() {
    this.tenant = localStorage.getItem("EPS-tenant");
  },
  mounted() {},
};
</script>

<style>
</style>